import { Cookies } from '../libs';

/**
 * Handle Dynamic Yield Cookie.
 */
window.addEventListener( 'load_triggered_script.tao', function() {
	// the _dyid cookie does not exist - we don't need to set a server cookie without an existing client.
	if ( ! Cookies.get( '_dyid' ) ) {
		return;
	}

	// The dyid_server cookie was already set in the last 7 days, so we don't need to call the server again.
	if ( Cookies.get( '_dyid_server' ) && Cookies.get( '_dyid_set' ) ) {
		return;
	}

	// Settings for Fetch.
	const settings = {
		credentials: 'include',
		mode: 'no-cors',
	};

	// Call Server - This sets the _dyid_server Cookie in Response Header.
	fetch( '/cms/dispatch/cookie/dynamic-yield/', settings ).then( () => {
		// Set a cookie for seven days, so we refresh the cookie when accessed again after that period.
		Cookies.set( '_dyid_set', 1, { expires: 7 } );
	} );
} );

window.addEventListener( 'UC_GENERAL', function( e ) {
	if ( e.detail && e.detail.event === 'consent_status' ) {
		const consentStatus = e.detail[ 'Dynamic Yield' ];
		window.DY.userActiveConsent = {
			accepted: consentStatus,
		};

		window.DYO.ActiveConsent.updateConsentAcceptedStatus( consentStatus );
		window.localStorage.setItem( 'DYUserActiveConsent', consentStatus );
	}
} );
